import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import PhotoBox from "./index";

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const VenuePhotos: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venue } = props;

  return <PhotoBox photos={venue.photos} venueId={venueId} />;
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state)
  };
};
const connector = connect(mapState);

export default connector(VenuePhotos);
